import { Tooltip as ChakraTooltip, Portal } from '@chakra-ui/react';
import * as React from 'react';

export interface TooltipProps extends ChakraTooltip.RootProps {
	content:       React.ReactNode
	contentProps?: ChakraTooltip.ContentProps
	disabled?:     boolean
	portalled?:    boolean
	portalRef?:    React.RefObject<HTMLElement>
	showArrow?:    boolean
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(props, ref) {
	const {
		children,
		content,
		contentProps,
		disabled,
		portalled = true,
		portalRef,
		showArrow,
		...rest
	} = props;

	if (disabled) return children;

	return (
		<ChakraTooltip.Root {...rest}>
			<ChakraTooltip.Trigger asChild>
				{children}
			</ChakraTooltip.Trigger>
			<Portal container={portalRef} disabled={!portalled}>
				<ChakraTooltip.Positioner>
					<ChakraTooltip.Content ref={ref} {...contentProps}>
						{showArrow && (
							<ChakraTooltip.Arrow>
								<ChakraTooltip.ArrowTip />
							</ChakraTooltip.Arrow>
						)}
						{content}
					</ChakraTooltip.Content>
				</ChakraTooltip.Positioner>
			</Portal>
		</ChakraTooltip.Root>
	);
});
